import { Image as ChakraImage } from '@chakra-ui/react';
import React from 'react';
const Image = ({ imageURI, width, height, borderWidth, borderColor, borderRadius, margin, onPress, maxHeight = height, }) => {
    // Render
    return (<ChakraImage src={imageURI} height={height} width={width} borderColor={borderColor} margin={margin} onClick={onPress} maxHeight={maxHeight} borderRadius={borderRadius} borderWidth={borderWidth}/>);
};
export default Image;
